// extracted by mini-css-extract-plugin
export default {"wrapper":"Promo_wrapper__KAUOI","subtitle":"Promo_subtitle__8Dgce"};